import React, { useEffect, useState } from "react";
import AddSeason from "./AddSeason";
import ShowSeason from "./ShowSeason";
import "./Season.css";
import { config } from "../../../../../config";
import axiosApi from "../../../../../core/interceptor/interceptor";

export default function SeasonPopup(props) {
    const [showSeasons, setShowSeasons] = useState(true);
    const [season, setSeason] = useState({});
    const [fromSubmitted, setFromSubmitted] = useState(false);
    const [type, setType] = useState('view');
    const selectSeason = (seas) => {
        setSeason(seas)
    };
    const closeModal = (e = null) => {
        props.closeModal && props.closeModal(e);
    };

    useEffect(() => {
        setFromSubmitted(false);
        if (type === 'add' || showSeasons) {
            setSeason({});
        }
    }, [type, showSeasons]);

    /**** Triggers when form submit *****/
    const handleSubmit = (event) => {
        event.preventDefault();
        setFromSubmitted(true);
        if (showSeasons) {
            return closeModal(season);
        } else {

        }
        if (season && season.name) {
            if (season.id) {
                updateSeason();
            } else {
                addSeason();
            }
        }
    }

    /***** Triggers when form data changes ******/
    const handleFormChange = (event) => {
        setSeason((prevSeason) => ({
            ...prevSeason,
            [event.target.name]: event.target.value,
        }));
    }

    function updateSeason() {
        axiosApi.put(`${config.apiUrl}/seasons/${Number(season.id)}`, {
            name: season.name || '',
        }).then((resp) => {
            setShowSeasons(true);
            setFromSubmitted(false);
        }).catch((err) => {

        })
    }

    function addSeason() {
        axiosApi.post(`${config.apiUrl}/seasons`, {
            name: season.name || '',
        }).then((resp) => {
            setShowSeasons(true);
            setFromSubmitted(false);
        }).catch((err) => {

        })
    }
    return <>
        <div className="modal season-popup">
            <form onSubmit={handleSubmit}>
                {
                    showSeasons
                        ? <ShowSeason
                            showSeasons={setShowSeasons}
                            emitSeason={selectSeason}
                            setType={setType}
                            closeModal={closeModal}
                            copy={props.copy} 
                            NotShowAll = {props.NotShowAll ? props.NotShowAll : false} />
                        : <AddSeason
                            mode={type}
                            season={(season && season.name ? season.name : '')}
                            handleFormChange={handleFormChange}
                            closeModal={closeModal}
                            fromSubmitted={fromSubmitted} />
                }
                <div className="modal-footer d-flex">
                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={
                            (e) => {
                                if (season && season.id > 0) {
                                    e.preventDefault();
                                    showSeasons && setType('edit');
                                    setShowSeasons(show => !show);
                                } else {
                                    if (type === 'add') {
                                        setType('view');
                                        setShowSeasons(show => !show);
                                    }
                                }
                            }
                        }>{showSeasons ? 'Edit Season' : 'Cancel'}</button>
                    <button>Confirm</button>
                </div>
            </form>
        </div>
    </>
}
